import store from '@/state/store';
import projectSlice from '@/state/project.slice';
// import commonSlice from '@/state/common.slice';
// import { FolderTreeNodeStats } from '@bimdata/definitions/dto';

export default (): void => {
  store.dispatch(projectSlice.actions.close());
};
